import { API7 } from "../apiAuth";

const getUserInfo = async () => {
    try {
        const response = await API7.post(`session/user-info`,{},{ withCredentials: true});  
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

const getDuplicateCheck = async (body) => {
    try {
        const response = await API7.post(`session/duplicate-check`,body);  
        return response.data;
    } catch (error) {
        return error.response.data;
    }
};

const getUserState = async (no) => {
    try {
        const response = await API7.get(`user/user_info?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const getUserWallet = async (no) => {
    try {
        const response = await API7.get(`user/get_userbalance_list?user_no=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postStartTrading = async (no) => {
    try {
        const response = await API7.post(`user/start_trading?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postChargeSeed = async (userNo,seed) => {
    try {
        const response = await API7.post(`user/charge_seed?retri_id=${userNo}&seed=${seed}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

const postResetUser = async (no) => {
    try {
        const response = await API7.post(`user/reset_user?retri_id=${no}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

export default {
    getUserInfo,
    getDuplicateCheck,
    getUserState,
    postStartTrading,
    postResetUser,
    getUserWallet,
    postChargeSeed,
};
